import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ServicesService } from '../my-profile/services.service';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { UserDetailsService } from '../services/user-details.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-user-friends',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './user-friends.component.html',
  styleUrl: './user-friends.component.css'
})
export class UserFriendsComponent {

  is_friends = 'Friends'
  baseUrl: string = 'http://localhost:4200';
  friends: any[] = [];
  private taskservices = inject(ServicesService);
  userData: any = {};
  is_myProfile: boolean = false;
  showErrorMessage: boolean = false;
  loader: boolean = true;
  loader2: boolean = true;
  private userDetailsSubscription!: Subscription;

  user_friends() {
    if (this.is_myProfile) {
      this.taskservices.close_task(this.is_friends);
    } else {
      this.taskservices.isViewSubject.next("Friends");
    }
  }

  constructor(private apiservices: ApiServicesService, private snackbarService: SnackbarService, private userdetails: UserDetailsService) { }

  ngOnInit() {
    // this.getFriendList();
    this.userDetailsSubscription = this.userdetails.userdetails$.subscribe((userData) => {
      if(userData!==null){
      if (userData) {
        this.userData = userData;
        this.loader = true;
        this.getFriendList();
        if (this.userData?.user?._id) {
          this.loader2 = false;
          this.is_myProfile = this.apiservices.checkProfile(this.userData.user.username);
        }
      }
    }else{
      this.loader=true;
      this.loader2=true;

    }
    });
  }

  ngOnDestroy(): void {
    if (this.userDetailsSubscription) {
      this.userDetailsSubscription.unsubscribe();
    }
  }

  getProfileLink(username: string) {
    const is_myProfile = this.apiservices.checkProfile(username);
    if (is_myProfile) {
      return ['/my-profile', username, 'Profile']
    } else {
      return ['/member-profile', username, 'Profile']
    }
  }

  getFriendList() {
    this.showErrorMessage = false;
    if (this.userData?.user?._id) {
      this.apiservices.getFriendList(this.userData.user._id, 1, 4).subscribe({
        next: (friends: any) => {
          if(friends.status==200){
          this.loader = false;
          this.friends = friends?.friends || [];
          }else{
            this.loader = false;
            if (friends.message == "Friend list is private.") {
              this.showErrorMessage = true;
              this.friends = [];
            }

          }
        },
        error: (err) => {
          this.loader = false;
 
          if (err.error.message == "Friend list is private.") {
            this.showErrorMessage = true;
            this.friends = [];
          }
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    }
  }
}
